import DashboardingFilters from './DashboardingFilters.vue'

export default DashboardingFilters
